import { render } from "./Error.vue?vue&type=template&id=07073c1a&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=07073c1a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/spinwheel-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07073c1a"]])

export default __exports__